var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticStyle:{"position":"absolute","bottom":"15px","left":"10px"},attrs:{"small":"","color":"secondary"}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }